import { useState, useEffect } from 'react';
import { Tabs, Space, Table } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import { Print, Save, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import Utilis from '../../../../Models/Utilis';
import DistantProfils from '../../../../Models/DistantProfils';
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import Hash from '../../../../Functions/Security/Hash';
import { Box, Typography, styled } from '@mui/material';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import DataTypeTable from '../../../../Types/DataTypeTable';
import Datas from "../../../../Data/Data.json";
import { ColumnsType } from 'antd/es/table';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Garantie from '../../../../Models/Garantie';
import Caisse from '../../../../Models/Caisse';
import InputForm from '../../../InputT';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import { PrintEtatCaisseDirect } from '../../../../utilitaires/globalFunction';
import { LoadBilletage } from '../../../../Functions/Traitement/LoadBilletage';



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const ArreterCaisse = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const navigate = useNavigate()

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")
  const [action, setAction] = useState("")

  const [Data, SetData] = useState<DataTypeTable[]>([]);
  const [scroll, setScrool] = useState<any>({ y: 250, x: 10 })
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [pageLoad, setPageLoad] = useState(true)


  const [caisse, setCaisse] = useState<any>()

  const ThemeTable = styled(Table)(({ theme }) => ({

    ".ant-table-body ": {
      height: '185px',
      borderBottom: '1px var(--colorOpaque020) solid',
    }

  }
  ));

  setTimeout(() => {
    if (selectedRowKeys.length == 0) {
    }
    try {
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        setSelectedRowKeys([])
        //localStorage.clear()
      }
    }
    catch (error) {
      console.log(error)
    }
  }, 1);


  const onSelectChange = (newSelectedRowKeys: any) => {

    console.log('selectedRowKeys changed: ', Data[newSelectedRowKeys]);
    form.setFieldsValue(Data[newSelectedRowKeys])

    setSelectedRowKeys(newSelectedRowKeys);
  }; const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    setModifActve(true)
    form.resetFields()
    form.setFieldValue("niveau", 900)
    localStorage.setItem(Datas.LocalVariable.reset, "0")
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
    setModifActve(false)
  }
  function handleAnulle() {
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    localStorage.clear()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()
    localStorage.setItem(Datas.LocalVariable.reset, "1")
    SetData([])
    //localStorage.setItem(Datas.LocalVariable.resetTable, "1")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
    setAnnulActive(false)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Détails caisse
        </span>
      ),
      children: <Tab1 form={form} />,
    }
  ];


  if (pageLoad) {
    setPageLoad(false)
    LoadTillInformation()
  }


  function LoadTillInformation() {
    setLoading(true)
    let utilis: Utilisateur = user
    //alert(JSON.stringify(utilis))
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetTillStatut,
      headers: {
        'CipherUser': Crypter.encrypt(JSON.stringify(utilis)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          if (res.StatutCode == 200) {
            localStorage.clear()
            form.setFieldsValue(res.Result[0])
            form.setFieldValue("totalDec", (res.Result[0].CLOSPT + res.Result[0].MTSTFDBANQ + res.Result[0].MTEMCOFF + res.Result[0].MTDIVEM))
            form.setFieldValue("totalEncais", (res.Result[0].EEDTJE + res.Result[0].CLOSVT + res.Result[0].MTENFDBANQ + res.Result[0].MTRECOFF + res.Result[0].MTDIVRE))
            form.setFieldValue("difference", (parseInt(res.Result[0].EETSRL) - parseInt(res.Result[0].EEPEAE)))


            // alert(JSON.stringify(res.Result[0]))
            setCaisse(res.Result[0])
            form.setFieldValue("NODECE", res.Result[0].NODECE)
            form.setFieldValue("CAIUTI", res.Result[0].CAIUTI)

            if ((res.Message as String).includes('fermé')) {
              setEnregActve(false)

            } else {
              //navigate("/")
              SweetAlert.fire({ title: res.Message, icon: "warning" })
            }
            // chargement du billetage
            LoadBilletage({
              form: form,
              authHeader: authHeader(),
              user: user,
              Ref: res.Result[0].NODECE,
              ColRef: "CodeCaisse",
              Table: 'billetageCaisse'
            })
          }
          else {
            // alert("yetooooo")
            navigate("/")
            SweetAlert.fire({ title: res.Message, icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        navigate("/")
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }
  const onFinish = (values: any) => {
    var cai: Caisse = form.getFieldsValue()
    cai.NODECE = caisse.NODECE
    cai.LECEON = caisse.LECEON
    cai.CDETAT = caisse.CDETAT
    cai.AEGECE = user.codage
    cai.NMURCR = user.coduti
    cai.CAIUTI = user.nomuti
    cai.NUMCPT = caisse.NUMCPT
    cai.EETSRL = ReformatNumber(cai.EETSRL + "")

    cai.TYPCAI = form.getFieldValue("TYPCAI")

    SweetAlert.fire({
      title: "Voulez vous effectuer l'arrêté de la caisse\n(" + caisse.NODECE + ' - ' + caisse.LECEON + ")",
      showCancelButton: true,
      color: "#116599",
      confirmButtonText: "Yes",
      confirmButtonColor: "#116599",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      icon: 'question'
    }).then((res) => {
      if (res.isConfirmed) {
        setLoading(true);
        setIsSubmit(true)

        //console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(garantie)));

        let data = Crypter.encrypt(JSON.stringify(cai));

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: Datas.ApiUrl.ArreterCaisse,
          headers: {
            //'CypherGarantie': data,
            'Authorization': authHeader(),
            'Content-Type': 'application/json'
          },
          data: data
        };

        axios.request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;

              if (res.StatutCode == 200) {
                setIsSubmit(false)
                SweetAlert.fire({ title: res.Message, icon: "success" })

                initialiazeButton()
                setSbmit("")
                SetData([])

                // Impression Etat
                Print(caisse)

              }

              else {
                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log(error)
            SweetAlert.fire({ title: "Error", text: error, icon: "error" })
          });

      }
    })
  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function ArreterCaisse() {
    let numidentity = form.getFieldValue("codgar")
    let numcli = form.getFieldValue("NUMCLI")
    let libelle = form.getFieldValue("lib_codgar")

    SetData([])

    if ((numidentity == undefined && numcli == undefined) || (numidentity == '' && numcli == '') || (numidentity == '' && numcli == undefined) || (numidentity == undefined && numcli == '')) {
      SweetAlert.fire({
        title: "Warning",
        text: "Enter search element",
        icon: 'warning'
      })
      return;
    }
    let data = (numidentity != undefined && numidentity != '') ? Crypter.encrypt(JSON.stringify(numidentity + Datas.LocalVariable.separator + "ID")) : Crypter.encrypt(JSON.stringify(numcli + Datas.LocalVariable.separator + "CL"));
    console.log(data)
    if (data.length != 0) {
      initialiazeButton()
      setLoading(true)
      form.resetFields()
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.GetGarantie,
        headers: {
          'CypherSearch': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
              const datat: DataTypeTable[] = [];
              console.log(res)
              //alert(JSON.stringify(res))
              var garantie: Garantie = res.Result.Table[0];
              garantie.DATDEB = ReformatDate(garantie.DATDEB)
              garantie.DATFIN = ReformatDate(garantie.DATFIN)
              form.setFieldsValue(garantie)
              form.setFieldValue('lib_codgar', form.getFieldValue("DESIGNATION"))

              let garanties = res.Result.Table1;

              if (garanties.length === 0) {
                //console.log("aucun élément ");
                SetData([])
              }
              else {
                garanties.map((data: any, indice: number) => {
                  //console.log(JSON.stringify(data))
                  datat.push({
                    key: indice,
                    NUMIDENTI: data.NUMIDENTI,
                    NUMCLI: data.NUMCLI,
                    lib_NUMCLI: data.lib_NUMCLI,
                    codgar: data.codgar,
                    lib_codgar: data.lib_codgar,
                    LOCAL: data.LOCAL,
                    VALGARANTI: data.VALGARANTI,
                    DESIGNATION: data.DESIGNATION,
                    DATDEB: ReformatDate(data.DATDEB),
                    DATFIN: ReformatDate(data.DATFIN),
                    TEXTCOMMEN: data.TEXTCOMMEN,
                    fichier: data.fichier,
                    valCouvert: data.valCouvert,
                    dispo: data.dispo,
                    UTILIS: data.UTILIS,
                    DATCRE: data.DATCRE,
                    UTIVAL: data.UTIVAL,
                    DATVAL: data.DATVAL,
                    CDETAT: data.CDETAT
                  });
                  SetData(datat);
                })
              }



              localStorage.clear()
              initialiazeButton()

              cunsultButton()
              setImpActive(false)

            }
            else {
              form.setFieldValue("codgar", numidentity)
              form.setFieldValue("NUMCLI", numcli)
              form.setFieldValue("lib_codgar", libelle)
              SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          form.setFieldValue("codgar", numidentity)
          form.setFieldValue("lib_codgar", libelle)
          form.setFieldValue("NUMCLI", numcli)
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error, icon: "error" })
        });
    }

  }

  function Print(dataPrint: any) {
    try {
      localStorage.setItem(Datas.LocalVariable.etatCaisse, JSON.stringify({ "form": { ...dataPrint, titre: "ETAT ARRETE CAISSE" } }))
      //navigate("/caisse/ouverturefermeture/print")
      PrintEtatCaisseDirect(user.codage, user.agence, user.nomuti, form.getFieldValue("NODECE"), user.coduti)
    } catch (error) {
      SweetAlert.fire({
        title: "Warning",
        text: JSON.stringify(error),
        icon: "warning"
      })
    }
  }

  function OuvertureCaisse() {
    setAction("O")
  }
  function FermetureCaisse() {
    setAction("F")
  }


  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>ARRETER DE CAISSE </b></Typography>
      <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"#116599"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size='large' className='bt_add' disabled={enregActve} onClick={FermetureCaisse} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' onClick={() => {
                  //Print(form.getFieldsValue())
                  PrintEtatCaisseDirect(user.codage, user.agence, user.nomuti, form.getFieldValue("NODECE"), user.coduti)
                }} className='bt_add' disabled={false} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button>

                {/* <Button size='large' onClick={()=>{Print(form.getFieldsValue())}} className='bt_add' disabled={false} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button> */}
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default ArreterCaisse;